<template>
    <div>       
        <b-tabs class="emisiones" v-model="tabIndex">
            <b-tab active>
                <template slot="title">
                    <h6 class="colorEmision">Emision</h6>
                    <div class="separador"></div>
                </template>
                <template v-if="tabIndex == 0">
                    <boleta-emision @tabindex="changeTab"></boleta-emision>
                </template>
            </b-tab>
            <b-tab title="Emitidas">
                <template v-if="tabIndex == 1">
                    <boleta-consulta :reload="reload" @tabindex="changeTab"></boleta-consulta>
                </template>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <h6 class="colorEmision">NC Emision</h6>
                    <div class="separador"></div>
                </template>
                <template v-if="tabIndex == 2">
                    <nota-credito-boleta-emision></nota-credito-boleta-emision>
                </template>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <h6>NC Consulta</h6>
                </template>
                <template v-if="tabIndex == 3">
                    <nota-credito-boleta-consulta></nota-credito-boleta-consulta>
                </template> 
            </b-tab>
            <b-tab>
                <template slot="title">
                    <h6 class="colorEmision">ND Emision</h6>
                    <div class="separador"></div>
                </template>
                <template v-if="tabIndex == 4">
                    <nota-debito-boleta-emision></nota-debito-boleta-emision>
                </template>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <h6>ND Consulta</h6>
                </template>
                <template v-if="tabIndex == 5">
                    <nota-debito-boleta-consulta></nota-debito-boleta-consulta>
                </template>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <h6 class="colorEmision">Emision masiva</h6>
                    <div class="separador"></div>
                </template>
                <template v-if="tabIndex == 6">
                    <subir-boletas></subir-boletas>
                </template>
            </b-tab>
        </b-tabs>
        <vue-snotify></vue-snotify>
    </div>
</template>

<script>
import BoletaEmision from '@/components/boleta/BoletaEmision'
import BoletaConsulta from '@/components/boleta/BoletaConsulta'
import NotaCreditoBoletaConsulta from '@/components/notacredito/NotaCreditoBoletaConsulta'
import NotaCreditoBoletaEmision from '@/components/notacredito/NotaCreditoBoletaEmision'
import NotaDebitoBoletaEmision from '@/components/notadebito/NotaDebitoBoletaEmision'
import NotaDebitoBoletaConsulta from '@/components/notadebito/NotaDebitoBoletaConsulta'
import SubirBoletas from '@/components/cargamasivaboleta/SubirBoletas'
// import { tabBoletas } from 'vuex'

export default {
    name: 'Boleta',
    components: {
        BoletaEmision,
        BoletaConsulta,
        NotaCreditoBoletaConsulta,
        NotaCreditoBoletaEmision,
        NotaDebitoBoletaEmision,
        NotaDebitoBoletaConsulta,
        SubirBoletas
    },
    data: () => {
        return {
            tabIndex: 0,
            emitido: false,
            reload: false
        }
    },
    methods: {
        changeTab(value){
            this.emitido = true,
            this.tabIndex = value
        }
    },
    watch: {
        tabIndex: function  (){
            if(this.tabIndex == 1 && this.emitido){
                this.reload = true
                this.emitido = false
            }else{
                this.reload = false
                this.emitido = false
            }
        }
    }
}
</script>

<style>
.colorEmision {
    font-weight: bold;
    color: #00004d;
}
.separador{
    background-color: #ffc12c;
    width: 100%;
    height: 2px
}
.emisiones{
    margin-top: -1%;
}
</style>
